import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MantineReactTable } from "mantine-react-table";
import AddUser from "./AddUser";
import { GetUser, HEADERS } from "../api";
import { getOrgId, DeleteUsers, getDepId, getroleName } from "../api";
import Swal from "sweetalert2";

const Tables = () => {
  const [showAddUser, setShowAddUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const toggleAddUser = () => {
    setShowAddUser(!showAddUser);
  };

  const handleDelete = async (userID) => {
    const user = selectedUser.find((u) => u.user_id === userID);
    if (user?.user_role_name === "Root User") {
      await Swal.fire("Forbidden", "You cannot delete a root user.", "error");
      return;
    }
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this employee",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
      });

      if (!confirmDelete.isConfirmed) {
        return;
      }

      const orgID = getOrgId();
      const response = await axios.post(
        DeleteUsers,
        {
          user_id: userID,
          organization_id: orgID,
        },
        { headers: HEADERS }
      );

      if (response.data.response_code === "0000") {
        await Swal.fire("Deleted!", "Employee has been deleted.", "success");
        window.location.reload();
      } else {
        await Swal.fire(
          "Failed!",
          "Failed to delete the employee. Please try again later.",
          "error"
        );
        console.error("Error deleting employee:", response.data);
      }
    } catch (error) {
      console.error("An error occurred while deleting employee:", error);
      await Swal.fire("Error", "Unexpected error, please try again.", "error");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      const DepId = getDepId();
      try {
        const requestData = { org_id: OrgID, dept_id: DepId };
        const response = await axios.post(GetUser, requestData, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          setSelectedUser(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const lowerCaseRole = getroleName();
  const userRole = lowerCaseRole.toLowerCase();

  const tableData = Array.isArray(selectedUser)
    ? selectedUser.map((user) => ({
        user_id: user.user_id,
        employee_code: user.employee_code,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        user_role_name: user.user_role_name,
        user_role_id: user.user_role_id,
        job_title: user.job_title,
        employee_type_name: user.employee_type_name,
        employee_type: user.employee_type,
        department_name: user.department_name,
        department: user.department,
        location_name: user.location_name,
        user_location: user.user_location,
        employee_status_name: user.employee_status_name,
        employee_status: user.employee_status,
        leave_policy_name: user.leave_policy_name,
        leave_policy: user.leave_policy,
        holiday_type_name: user.holiday_type_name,
        holiday_type: user.holiday_type,
        leave_approved_by: user.leave_approved_by,
        is_head: user.is_head,
        address_1: user.address_1,
        address_2: user.address_2,
        user_state: user.user_state,
        city: user.city,
        zip_code: user.zip_code,
        country: user.country,
        gender: user.gender,
        country_code: user.country_code,
        phone_no: user.phone_no,
        hire_date: user.hire_date,
        separation_date: user.separation_date,
        dob: user.dob,
        edit: (userRole === "admin" || userRole === "root user") && (
          <Link
            to={`/updateusers?user_id=${encodeURIComponent(
              user.user_id
            )}&first_name=${encodeURIComponent(
              user.first_name
            )}&last_name=${encodeURIComponent(
              user.last_name
            )}&email=${encodeURIComponent(
              user.email
            )}&user_role_name=${encodeURIComponent(
              user.user_role_name
            )}&user_role_id=${encodeURIComponent(
              user.user_role_id
            )}&employee_code=${encodeURIComponent(
              user.employee_code
            )}&job_title=${encodeURIComponent(
              user.job_title
            )}&employee_type_name=${encodeURIComponent(
              user.employee_type_name
            )}&employee_type=${encodeURIComponent(
              user.employee_type
            )}&department_name=${encodeURIComponent(
              user.department_name
            )}&department=${encodeURIComponent(
              user.department
            )}&location_name=${encodeURIComponent(
              user.location_name
            )}&user_location=${encodeURIComponent(
              user.user_location
            )}&employee_status_name=${encodeURIComponent(
              user.employee_status_name
            )}&employee_status=${encodeURIComponent(
              user.employee_status
            )}&leave_policy_name=${encodeURIComponent(
              user.leave_policy_name
            )}&leave_policy=${encodeURIComponent(
              user.leave_policy
            )}&holiday_type_name=${encodeURIComponent(
              user.holiday_type_name
            )}&holiday_type=${encodeURIComponent(
              user.holiday_type
            )}&leave_approved_by=${encodeURIComponent(
              user.leave_approved_by
            )}&is_head=${encodeURIComponent(
              user.is_head
            )}&address_1=${encodeURIComponent(
              user.address_1
            )}&address_2=${encodeURIComponent(
              user.address_2
            )}&user_state=${encodeURIComponent(
              user.user_state
            )}&city=${encodeURIComponent(
              user.city
            )}&zip_code=${encodeURIComponent(
              user.zip_code
            )}&country=${encodeURIComponent(
              user.country
            )}&gender=${encodeURIComponent(
              user.gender
            )}&country_code=${encodeURIComponent(
              user.country_code
            )}&phone_no=${encodeURIComponent(
              user.phone_no
            )}&hire_date=${encodeURIComponent(
              user.hire_date
            )}&separation_date=${encodeURIComponent(
              user.separation_date
            )}&dob=${encodeURIComponent(user.dob)}`}
          >
            <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} />
          </Link>
        ),

        delete: (userRole === "admin" || userRole === "root user") &&
          user.user_role_name !== "root user" && (
            <FontAwesomeIcon
              icon={faTrash}
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(user.user_id)}
            />
          ),
      }))
    : [];

  const columns = [
    {
      accessorKey: "employee_code",
      header: "Code",
      width: 100,
    },
    {
      accessorKey: "first_name",
      header: "First Name",
    },
    {
      accessorKey: "last_name",
      header: "Last Name",
    },
    {
      accessorKey: "department_name",
      header: "Department",
    },
    {
      accessorKey: "location_name",
      header: "Location",
    },
    {
      accessorKey: "job_title",
      header: "Job Title",
    },
    {
      accessorKey: "gender",
      header: "Gender",
    },
    {
      accessorKey: "user_role_name",
      header: "Role",
    },
    {
      accessorKey: "edit",
      header: "Edit",
    },
    {
      accessorKey: "delete",
      header: "Delete",
    },
  ];

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);

  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  return (
    <div className="row-container">
      {!showAddUser && (
        <div className="d-flex justify-content-between pb-3">
          <div>
            <span className="title">Employee List</span>
          </div>
          <div className="buttons">
            {(userRole === "admin" || userRole === "root user") && (
              <Link to="">
                <button className="border add-button" onClick={toggleAddUser}>
                  Add Employee
                </button>
              </Link>
            )}
          </div>
        </div>
      )}
      {showAddUser ? null : (
        <div>
          <MantineReactTable
            columns={columns}
            data={paginatedData}
            enableFullScreenToggle={false}
            mantineTableBodyCellProps={{
              style: {
                backgroundColor: "#C8E3EC60",
                color: "#505050",
                border: "0.5px solid #fff",
                padding: "10px",
              },
            }}
            mantineTableHeadCellProps={{
              style: {
                backgroundColor: "#2d7d9f",
                fontSize: "14px",
                fontWeight: 500,
                color: "#fff",
                border: "1px solid #fff",
              },
            }}
            mantineTableBodyRowProps={(row) => ({
              style: {
                backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
              },
            })}
            enablePagination={false}
            enableColumnOrdering
            manualPagination
            pageCount={Math.ceil(tableData.length / pageSize)}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            state={{ pageIndex: page, pageSize: pageSize }}
          />
          <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px" }}>Items per page:</span>
              <select
                className="form-select"
                style={{ width: "110px" }}
                value={pageSize}
                onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
              >
                <option value={5}>5 rows</option>
                <option value={10}>10 rows</option>
                <option value={20}>20 rows</option>
                <option value={50}>50 rows</option>
                <option value={100}>100 rows</option>
              </select>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <span style={{ fontSize: "14px" }}>
                {totalRows === 0
                  ? "Showing 0 to 0 of 0 entries"
                  : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
              </span>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-3">
              <button
                className="previous-button"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
              >
                Previous
              </button>
              <button
                className="add-button text-center justify-content-center"
                style={{ width: "100px" }}
                onClick={() => handlePageChange(page + 1)}
                disabled={(page + 1) * pageSize >= tableData.length}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      {showAddUser && <AddUser />}
    </div>
  );
};

export default Tables;
